import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-book-open-line text-2xl" style={{ color: `oklch(var(--primary-500))` }}></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-900">
              韩漫之家
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button className="px-4 py-2 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-full transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 border border-background-200/70 rounded-lg p-2 grid grid-cols-4 gap-1 min-w-[480px]">
                  {categories.map((cat) => (
                    <Link
                      key={cat.id}
                      to={`/category/${cat.id}`}
                      className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <span className={`w-7 h-7 flex items-center justify-center rounded-md ${cat.color}`}>
                        <i className={`${cat.icon} text-xs`}></i>
                      </span>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer">
              <i className="ri-search-line text-lg text-foreground-700"></i>
            </button>
            <button className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              登录 / 注册
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl text-foreground-700 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          <Link
            to="/"
            className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
          >
            首页
          </Link>
          <div className="px-4 py-3 text-sm font-medium text-foreground-700">
            分类浏览
          </div>
          <div className="grid grid-cols-2 gap-1 px-4 pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-600 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className={`w-6 h-6 flex items-center justify-center rounded ${cat.color}`}>
                  <i className={`${cat.icon} text-[10px]`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
          </div>
          <Link
            to="/about"
            className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
          >
            关于我们
          </Link>
          <div className="px-4 pt-3">
            <button className="w-full px-5 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              登录 / 注册
            </button>
          </div>
        </div>
      )}
    </header>
  );
}